import React from "react";
import { HashRouter as Router, Route, Routes } from 'react-router-dom'

import Home from "./components/Home"
import Artproject from "./components/Artproject";
import TechprojectList from "./components/TechprojectList";

import { artprojects } from "./ArtprojectData";


const Main = () => {
  return (
    <Router>
      <Routes>
          <Route path="/" element={<Home artprojects={artprojects} />} />
          {artprojects.map((project, index) => (
            <Route
              key={index}
              path={`/artproject/${project.path}`}
              element={<Artproject artproject={project} />}
            />
          ))}
          <Route path="/techprojects" element={<TechprojectList />} />
        </Routes>
    </Router>
  );
};

export default Main;